import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { Panes } from 'modules/core/components/Panes'
import { PanesPad } from 'modules/core/components/PanesPad'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import { useApiKeys } from 'modules/api_public/store/collections/apiKeys'
import illustration from 'modules/attendance/components/ActiveAttendance/illustration.svg'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import IllustratedBlankSlate from 'modules/surveys/components/IllustratedBlankSlate'

import CreateModal from './Modals/CreateModal'
import ReadModal from './Modals/ReadModal'
import KeyTable from './Table'
import { Action } from './types'

export interface State {
  createModal: boolean
  readModal: boolean
  keyName: string | null
  token: string | null
}

const initialState = { createModal: false, readModal: false, keyName: null, token: null }

function reducer(_state: State, action: Action): State {
  switch (action.type) {
    case 'showCreateModal':
      return { createModal: true, readModal: false, keyName: null, token: null }
    case 'showReadModal':
      return { createModal: false, readModal: true, keyName: action.keyName, token: action.token }
    case 'closeModals':
      return initialState
    default:
      throw new Error()
  }
}

const ApiKeySettings = () => {
  const apiKeys = useApiKeys()
  const [state, dispatch] = React.useReducer(reducer, initialState)
  const { loading } = useAsyncData(() => apiKeys.fetch(), [])
  const list = apiKeys.map((model) => model.toJS())

  return (
    <ResponsivePage.Body
      loading={loading}
      error={null}
      widget={
        <Button type="primary" onClick={() => dispatch({ type: 'showCreateModal' })}>
          {i18n.t('settings.api_keys.create_key')}
        </Button>
      }
    >
      {apiKeys.length <= 0 ? (
        <Panes direction="vertical">
          <PanesPad>
            <Box gap="s40">
              <IllustratedBlankSlate
                illustration={illustration}
                title={i18n.t('settings.api_keys.title')}
                description={i18n.t('settings.api_keys.empty_description')}
                linkHref="https://apidoc.factorialhr.com/#authentication"
                linkText={i18n.t('settings.api_keys.more_info')}
                ctaLabel={i18n.t('settings.api_keys.create_key')}
                onClick={() => dispatch({ type: 'showCreateModal' })}
              />
            </Box>
          </PanesPad>
        </Panes>
      ) : (
        <Panes direction="vertical">
          <PanesPad>
            <KeyTable keys={list} />
          </PanesPad>
        </Panes>
      )}
      {state.createModal && <CreateModal dispatch={dispatch} />}
      {state.readModal && (
        <ReadModal dispatch={dispatch} keyName={state.keyName ?? ''} token={state.token ?? ''} />
      )}
    </ResponsivePage.Body>
  )
}

export default observer(ApiKeySettings)
